import type { FC } from "react";
import QuickSearchContainer from "../../../containers/QuickSearch/quick-search.container";
import Button from "../Button";
import Logo from "../Logo";
import SpecialButton from "../SpecialButton";
import * as s from "./SiteMenu.module.scss";

type SiteMenuProps = {
	ariaLabelCartItems?: string;
	ariaLabelLogo?: string;
	ariaLabelMenu?: string;
	cartItemCount: number;
	onCartClick: () => void;
	onNavClick: () => void;
	showCart?: boolean;
	showQuickSearch?: boolean;
};

const SiteMenu: FC<SiteMenuProps> = ({
	ariaLabelCartItems,
	ariaLabelLogo,
	ariaLabelMenu,
	cartItemCount,
	onCartClick,
	onNavClick,
	showCart = true,
	showQuickSearch = true,
}) => (
	<div className={s.container}>
		{/* The div is needed for the design not to break. */}
		{showQuickSearch ? <QuickSearchContainer /> : <div />}
		<Logo className={s.logo} linkLabel={ariaLabelLogo ?? "link"} />
		{showCart && (
			<div className={s.buttonContainer}>
				<SpecialButton
					variant="cart"
					label={ariaLabelCartItems}
					itemCount={cartItemCount}
					onClick={onCartClick}
					open={false}
				/>
				<Button
					variant="container"
					buttonType="icon"
					icon="menu-burger"
					aria-label={ariaLabelMenu}
					className={s.menu}
					onClick={onNavClick}
				/>
			</div>
		)}
	</div>
);

export default SiteMenu;
